import React from 'react';
import { FiPlus, FiX } from 'react-icons/fi';
import './MultiPhoneInput.scss';

/**
 * Componente para gestionar múltiples números telefónicos con tipo
 * @param {Array} phones - Array de objetos con {number, type, is_primary}
 * @param {Function} onChange - Callback cuando cambian los teléfonos
 * @param {string} label - Etiqueta del campo
 * @param {boolean} required - Si el primer teléfono es obligatorio
 * @param {string} error - Mensaje de error
 */
const MultiPhoneInput = ({
  phones = [],
  onChange,
  label = "Teléfonos",
  required = false,
  error = null
}) => {
  // Inicializar con al menos un campo vacío si no hay teléfonos
  const phoneList = phones && phones.length > 0 ? phones : [];

  const handlePhoneChange = (index, field, value) => {
    const newPhones = [...phoneList];
    newPhones[index] = {
      ...newPhones[index],
      [field]: value
    };
    onChange(newPhones);
  };

  const addPhone = () => {
    const newPhones = [...phoneList, {
      number: '',
      type: 'mobile',
      is_primary: phoneList.length === 0
    }];
    onChange(newPhones);
  };

  const removePhone = (index) => {
    if (phoneList.length > 0) {
      const phoneToRemove = phoneList[index];
      const newPhones = phoneList.filter((_, i) => i !== index);

      // Si eliminamos el principal, hacer principal al primero
      if (phoneToRemove.is_primary && newPhones.length > 0) {
        newPhones[0].is_primary = true;
      }

      onChange(newPhones);
    }
  };

  return (
    <div className="multi-phone-input">
      <label className={`form-label ${required ? 'required' : ''}`}>
        {label}
      </label>

      {phoneList.length > 0 ? (
        <>
          <div className="phone-list">
            {phoneList.map((phone, index) => (
              <div key={index} className="phone-input-row">
                <select
                  className="form-input phone-type-select"
                  value={phone.type || 'mobile'}
                  onChange={(e) => handlePhoneChange(index, 'type', e.target.value)}
                >
                  <option value="mobile">Móvil</option>
                  <option value="office">Oficina</option>
                  <option value="home">Casa</option>
                  <option value="fax">Fax</option>
                  <option value="other">Otro</option>
                </select>

                <input
                  type="tel"
                  className={`form-input phone-number-input ${error && index === 0 ? 'error' : ''}`}
                  value={phone.number || ''}
                  onChange={(e) => handlePhoneChange(index, 'number', e.target.value)}
                  placeholder="(000) 000-0000"
                  maxLength={20}
                />

                <button
                  type="button"
                  className="btn-remove-phone"
                  onClick={() => removePhone(index)}
                  title="Eliminar teléfono"
                >
                  <FiX />
                </button>
              </div>
            ))}
          </div>

          <button
            type="button"
            className="btn-add-phone"
            onClick={addPhone}
          >
            <FiPlus /> Agregar Teléfono
          </button>
        </>
      ) : (
        <button
          type="button"
          className="btn-add-phone"
          onClick={addPhone}
        >
          <FiPlus /> Agregar Teléfono
        </button>
      )}

      {error && (
        <span className="form-error">{error}</span>
      )}
    </div>
  );
};

export default MultiPhoneInput;
